module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch0"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/Title_Page.htm"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch0a"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/Dedication.htm"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch0c"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/List_of_Maps.htm"
    }
  }, [_vm._v("List of Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch0d"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/Authors_Note.htm"
    }
  }, [_vm._v("Author’s note")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch0e"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/Preface.htm"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch0f"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/PART_I_EUROPE.htm"
    }
  }, [_c('span', {
    staticClass: "part"
  }, [_vm._v("PART I EUROPE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/1_Becoming_a_POW.htm"
    }
  }, [_vm._v("1. Becoming a POW")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/2_Settling_In_and_Getting_By.htm"
    }
  }, [_vm._v("2. Settling In and Getting By")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/3_Uses_for_a_Red_Cross_Parcel_Number_1__String.htm"
    }
  }, [_vm._v("3. Uses for a Red Cross Parcel Number 1 – String")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/4_Friendships_and_Feuds.htm"
    }
  }, [_vm._v("4. Friendships and Feuds")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/5_Sport.htm"
    }
  }, [_vm._v("5. Sport")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/6_Uses_for_a_Red_Cross_Parcel_Number_2__Cigarettes.htm"
    }
  }, [_vm._v("6. Uses for a Red Cross Parcel Number 2 – Cigarettes")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/7_Stalag_Happy__Imaginary_Worlds_and_Other_Ways_of_Escape.htm"
    }
  }, [_vm._v("7. ‘Stalag Happy’ – Imaginary Worlds and Other Ways of Escape")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/8_Uses_for_a_Red_Cross_Parcel_Number_3__Tins.htm"
    }
  }, [_vm._v("8. Uses for a Red Cross Parcel Number 3 – Tins")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9_POW_Artists.htm"
    }
  }, [_vm._v("9. POW Artists")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch9a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/PART_II_THE_WAR_IN_THE_EAST.htm"
    }
  }, [_c('span', {
    staticClass: "part"
  }, [_vm._v("PART II THE WAR IN THE EAST")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/10_Surrender.htm"
    }
  }, [_vm._v("10. Surrender")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/11_Changi.htm"
    }
  }, [_vm._v("11. Changi")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/12_Turned_Out_Rice_Again_Food_and_Cooking.htm"
    }
  }, [_vm._v("12. Turned Out Rice Again: Food and Cooking")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/13_Make_Do_and_Mend.htm"
    }
  }, [_vm._v("13. Make Do and Mend")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/14_Entertainment_Youll_Never_Get_Off_this_Island.htm"
    }
  }, [_vm._v("14. Entertainment: ‘You’ll Never Get Off this Island!’")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/15_Sport.htm"
    }
  }, [_vm._v("15. Sport")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/16_Recording_Captivity_Through_Art_and_Photography.htm"
    }
  }, [_vm._v("16. Recording Captivity Through Art and Photography")]), _c('a', {
    attrs: {
      "id": "pviii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/17_POW_Doctor.htm"
    }
  }, [_vm._v("17. POW Doctor")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/18_Taking_Flight_Escape_Through_Birdwatching.htm"
    }
  }, [_vm._v("18. Taking Flight: Escape Through Birdwatching")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/19_Survival_Teams.htm"
    }
  }, [_vm._v("19. Survival Teams")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/20_Escape_Through_Study.htm"
    }
  }, [_vm._v("20. Escape Through Study")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/21_University_of_Kuching.htm"
    }
  }, [_vm._v("21. University of Kuching")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/22_Languages_and_Communicating_with_the_Outside_World.htm"
    }
  }, [_vm._v("22. Languages and Communicating with the Outside World")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/23_Hidden_Wireless_Sets.htm"
    }
  }, [_vm._v("23. Hidden Wireless Sets")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/24_Religion.htm"
    }
  }, [_vm._v("24. Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/25_The_Magic_of_Letters_from_Home.htm"
    }
  }, [_vm._v("25. The Magic of Letters from Home")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/26_The_Changi_Murals.htm"
    }
  }, [_vm._v("26. The Changi Murals")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch26a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/PART_III_EUROPE.htm"
    }
  }, [_c('span', {
    staticClass: "part"
  }, [_vm._v("PART III EUROPE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/27_Reading_for_Profit.htm"
    }
  }, [_vm._v("27. Reading for Profit")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/28_Gardening_and_Birdwatching.htm"
    }
  }, [_vm._v("28. Gardening and Birdwatching")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/29_Study.htm"
    }
  }, [_vm._v("29. Study")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/30_Music_and_Theatre.htm"
    }
  }, [_vm._v("30. Music and Theatre")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch30a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/PART_IV_THE_FAR_EAST.htm"
    }
  }, [_c('span', {
    staticClass: "part"
  }, [_vm._v("PART IV THE FAR EAST")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/31_Upcountry_The_ThailandBurma_Railway.htm"
    }
  }, [_vm._v("31. ‘Upcountry’: The Thailand–Burma Railway")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/32_Art_and_Medicine_on_the_Railway.htm"
    }
  }, [_vm._v("32. Art and Medicine on the Railway")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/33_Archaeologist_on_the_Death_Railway.htm"
    }
  }, [_vm._v("33. Archaeologist on the ‘Death Railway’")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/34_Entertainment_and_Ingenuity_in_Thailand.htm"
    }
  }, [_vm._v("34. Entertainment and Ingenuity in Thailand")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/35_Home_Again_Changi_Gaol.htm"
    }
  }, [_vm._v("35. ‘Home’ Again: Changi Gaol")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/36_The_POW_Diaspora.htm"
    }
  }, [_vm._v("36. The POW Diaspora")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch36a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/PART_V_FREEDOM.htm"
    }
  }, [_c('span', {
    staticClass: "part"
  }, [_vm._v("PART V FREEDOM")])]), _c('a', {
    attrs: {
      "id": "pix"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/37_Somewhere_Near_the_End.htm"
    }
  }, [_vm._v("37. Somewhere Near the End")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/38_Victory_in_the_Far_East.htm"
    }
  }, [_vm._v("38. Victory in the Far East")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/39_Homecoming.htm"
    }
  }, [_vm._v("39. Homecoming")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch39a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/PART_VI_EXPOWS.htm"
    }
  }, [_c('span', {
    staticClass: "part"
  }, [_vm._v("PART VI EX-POWS")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/40_Aftermath.htm"
    }
  }, [_vm._v("40. Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch0b"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/Acknowledgements.htm"
    }
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/Acknowledgements.htm#Hd1",
      "id": "H1"
    }
  }, [_vm._v("Permissions")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch41"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/Notes.htm"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch42"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/Bibliography.htm"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch43"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/Index.htm"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch44"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/Copyright.htm"
    }
  }, [_vm._v("Copyright")])]), _c('a', {
    attrs: {
      "id": "px"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 63
// module chunks = 0